// 接口
// 域名
const domain = 'http://47.100.98.124';
// 路线
export const lineApi = `${domain}/prod-api/position/display/line`;
// 站点
export const stationApi = `${domain}/prod-api/position/display/station`;
// 列车
export const trainApi = `${domain}/prod-api/position/display/vehicleStatus`;
// 列车对应线路
export const trainEdgeApi = `${domain}/prod-api/position/display/platformEdge`;
// 站点到站点路径
export const stationsRoutesApi = `${domain}/prod-api/position/display/route`;
// 设置
export const settingApi = `${domain}/prod-api/position/display/displaySetting`;
// 巡站
export const patrolApi = `${domain}/prod-api/position/display/waitingDriverStatus`;
// 代理转发
export const agentGetApi = 'https://mazey.cn/server/agent/get';

// mock
export const url2Keys = new Map([
    ['position/display/line', 'positionDisplayLine'], // lineApi
    ['position/display/station', 'positionDisplayStation'], // stationApi
    ['position/display/platformEdge', 'positionDisplayPlatformEdge'], // trainEdgeApi
    ['position/display/route', 'positionDisplayRoute'], // stationsRoutesApi
    ['position/display/displaySetting', 'positionDisplayDisplaySetting'], // settingApi
    [
        'position/display/waitingDriverStatus',
        'positionDisplayWaitingDriverStatus',
    ], // patrolApi
]);

// Static Data Base Url
export const staticDataBaseUrl = 'data/metro/10';
